/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { WorldCheckOneCasesResponseDto } from '../../models/world-check-one-cases-response-dto';

export interface WorldCheckOneCases$Params {
  kycProcessId: string;
}

export function worldCheckOneCases(http: HttpClient, rootUrl: string, params: WorldCheckOneCases$Params, context?: HttpContext): Observable<StrictHttpResponse<WorldCheckOneCasesResponseDto>> {
  const rb = new RequestBuilder(rootUrl, worldCheckOneCases.PATH, 'get');
  if (params) {
    rb.query('kycProcessId', params.kycProcessId, {});
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<WorldCheckOneCasesResponseDto>;
    })
  );
}

worldCheckOneCases.PATH = '/screenings/worldcheck-one/screenshot';
